import { render, staticRenderFns } from "./ReasonTypeForm.vue?vue&type=template&id=e6acb8dc&"
import script from "./ReasonTypeForm.vue?vue&type=script&lang=js&"
export * from "./ReasonTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports